import React from "react";
import { FaEye } from "react-icons/fa";
import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { decrypt } from "../utils";
import { ID_TYPES } from "../Constant";
import { toast } from "react-toastify";
import { COMPLIANCE_REJECTED } from "../utilities";




const InvestorIdentityVerification = ({
    indivInvFormData,
    handleFieldChange,
    onBack,
    onNext,
    validateIdErrors,
    setValidateIdErrors,
    removeCompletedStep,
    handleIdentityChange,
    identityError,
    setIdentityError,
    handleSaveKYCDraft,
    setIndivInvFormData,
    handleViewFile,
    handleDeleteFile,
    setUploadedFiles,
    saveDraft,
    getFormData,
    investorKycId,
    currentStep,
    livenessSessionId,
    investorDatauser,

}) => {

    const [role_code, setRoleCode] = useState(Cookies.get("role_code"));


    useEffect(() => {
        if (role_code) {
            const decryptedValueData = decrypt(role_code)
            setRoleCode(decryptedValueData);
        }
    }, [])


    const idType1 = indivInvFormData?.idType1;

    const idType2 = indivInvFormData?.idType2;

    const UNIQUE_ID_TYPES = ["Passport", "National ID"];





    const idType1Options =
        idType2 && UNIQUE_ID_TYPES.includes(idType2)
            ? ID_TYPES.filter(type => type !== idType2)
            : ID_TYPES;

    const idType2Options =
        idType1 && UNIQUE_ID_TYPES.includes(idType1)
            ? ID_TYPES.filter(type => type !== idType1)
            : ID_TYPES;







    const validateMandatoryFields = () => {
        const newErrors = {};

        const idType1 = indivInvFormData?.idType1;
        const idType2 = indivInvFormData?.idType2;

        const isIdType1Passport = idType1 === "Passport";
        const isIdType2Passport = idType2 === "Passport";

        if (!idType1) newErrors.idType1 = true;
        if (!idType2) newErrors.idType2 = true;

        // ✅ Front images are ALWAYS required
        if (!indivInvFormData.id1FrontName) newErrors.id1Front = true;
        if (!indivInvFormData.id2FrontName) newErrors.id2Front = true;

        // ✅ Back images required ONLY if NOT passport
        if (!isIdType1Passport && !indivInvFormData.id1BackName) {
            newErrors.id1Back = true;
        }

        if (!isIdType2Passport && !indivInvFormData.id2BackName) {
            newErrors.id2Back = true;
        }

        setIdentityError(newErrors);
        setValidateIdErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const isIdType1Selected = Boolean(indivInvFormData?.idType1);
    const isIdType2Selected = Boolean(indivInvFormData?.idType2);

    const isIdType1Passport = indivInvFormData?.idType1 === "Passport";
    const isIdType2Passport = indivInvFormData?.idType2 === "Passport";
    const reason = investorDatauser?.kyc?.[0]?.admin_notes;

    const truncateWords = (text, limit = 35) => {
        if (!text) return "";

        if (text.length <= limit) return text;

        return text.substring(0, limit) + "...";
    };

    const renderKycStatus = () => {
        if (!investorDatauser?.kyc) return null;


        // if (reason) {
        if (investorDatauser?.kyc?.[0]?.status === COMPLIANCE_REJECTED) {

            return (
                <div className="kyc-status kyc-status-rejected">
                    <div>Status: Rejected</div>

                    <div className="kyc-reason">
                        Reason:
                        <span title={reason}
                            style={{ fontSize: "15px" }}>
                            {truncateWords(reason, 35)}
                        </span>
                    </div>
                </div>
            );
        }


        return null;
    };



    const truncateFileName = (name, maxLength = 40) => {
        if (!name) return "";
        return name.length > maxLength
            ? name.substring(0, maxLength) + "..."
            : name;
    };


    return (

        <div className="kyc-poppins-ui">
            <div className="main-content">
                <div className="content-wrapper">

                    <div className="review-header-row">
                        <div className="step-header">
                            <div className="step-title">Identity Verification</div>
                            <div className="step-subtitle">Upload clear photos of 2 different government-issued IDs.</div>
                        </div>
                        <div className="review-status">
                            {renderKycStatus()}
                        </div>
                    </div>




                    <div className="row mt-1">
                        <h6 className="section-title">
                            First ID Document</h6>
                    </div>
                    {/* ✅ ID TYPE #1 */}


                    <div className="row allow-gutter gy-3">

                        <div className="col-lg-6 settings_YOE ">
                            <label htmlFor="country" className="nomine-relation-label">

                                ID Type #1  <span className="required">*</span>
                            </label>

                            <select
                                className={`form-select dropdn_select_cls_settings shadow-ben APNL_option_flds ${validateIdErrors.idType1 ? "input-error" : ""
                                    }`}
                                value={idType1 || ""}


                                onChange={(e) => {
                                    const value = e.target.value;

                                    setIndivInvFormData(prev => {
                                        const updated = {
                                            ...prev,
                                            idType1: value,

                                            id1Front: "",
                                            id1FrontBlobUrl: "",
                                            id1FrontName: "",
                                            id1Back: "",
                                            id1BackBlobUrl: "",
                                            id1BackName: "",
                                        };

                                        localStorage.setItem(`indivInvData_${indivInvFormData?.user_id}`, JSON.stringify(updated));

                                        return updated;
                                    });

                                    setUploadedFiles(prev => {
                                        const updated = { ...prev };
                                        delete updated.id_front;
                                        delete updated.id_back;

                                        saveDraft({
                                            investorKycId,
                                            currentStep,
                                            formData: {
                                                ...getFormData(),
                                                idType1: value,
                                                id1Front: "",
                                                id1FrontBlobUrl: "",
                                                id1FrontName: "",
                                                id1Back: "",
                                                id1BackBlobUrl: "",
                                                id1BackName: "",
                                            },
                                            uploadedFiles: updated,
                                            livenessSessionId,
                                        });

                                        return updated;
                                    });


                                    if (
                                        value &&
                                        value === idType2 &&
                                        UNIQUE_ID_TYPES.includes(value)
                                    ) {
                                        handleFieldChange("idType2", "");
                                    }
                                }}
                            >
                                <option value="">Select</option>
                                {idType1Options.map((type) => (
                                    <option key={type} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>

                        </div>
                    </div>


                    {/*  UPLOAD SECTION */}


                    <div className="upload-grid">

                        {/* FRONT SIDE */}
                        <div className="form-group">
                            <label className="kyc-label">
                                Front Side <span className="required">*</span>
                            </label>

                            <div
                                className={`upload-area ${identityError.id1Front ? "input-error" : ""}
                                 ${indivInvFormData?.id1FrontName ? "has-file" : ""}
                                   ${!isIdType1Selected ? "upload-disabled" : ""}`}
                                id="id1FrontArea"
                                onClick={() => {
                                    if (!isIdType1Selected) {
                                        toast.error("Please select ID Type");
                                        return;
                                    }
                                    document.getElementById("id1Front").click();
                                }}
                            >
                                {!indivInvFormData?.id1FrontName && (

                                    <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                        <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                    </svg>
                                )}

                                {indivInvFormData?.id1FrontName && (

                                    <svg width="40" height="40" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10" fill="#10b981" />
                                        <path
                                            d="M8 12.5l2.5 2.5L16 9"
                                            fill="none"
                                            stroke="#ffffff"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}

                                <p className="upload-title">
                                    {indivInvFormData?.id1FrontName
                                        ? "Uploaded"
                                        : "Click to upload front side"}
                                </p>

                                <p className={`upload-hint ${indivInvFormData?.id1FrontName ? "hidden" : ""}`}>
                                    PNG, JPG up to 5MB
                                </p>

                                <span className="file-name"
                                    title={indivInvFormData?.id1FrontName || ""}
                                > {truncateFileName((indivInvFormData?.id1FrontName), 40) || "No file selected"}
                                </span>

                                {indivInvFormData?.id1FrontName && (
                                    <div
                                        className="file-actions"
                                        onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                    >
                                        {/* View */}
                                        <button
                                            type="button"
                                            className="icon-btn view"
                                            title="View file"
                                            onClick={() => handleViewFile("id_front")}

                                        >
                                            <FaEye
                                                className="eye-view-color-kyc"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"


                                            />
                                        </button>

                                        {/* REMOVE */}
                                        <button
                                            type="button"
                                            className="icon-btn cancel"
                                            title="Remove file"
                                            onClick={() => handleDeleteFile("id_front")}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </div>

                            <input
                                type="file"
                                id="id1Front"
                                accept="image/*"
                                hidden
                                disabled={!isIdType1Selected}
                                onChange={(e) => handleIdentityChange(e, "id1Front")}
                            />
                        </div>

                        {/* BACK SIDE */}
                        <div className="form-group">
                            <label className="kyc-label">
                                Back Side
                                {/* <span className="required">*</span> */}
                                {!isIdType1Passport && <span className="required">*</span>}
                            </label>

                            <div
                                className={`upload-area ${identityError.id1Back ? "input-error" : ""}
                                         ${indivInvFormData?.id1BackName ? "has-file" : ""}
                                          ${!isIdType1Selected ? "upload-disabled" : ""}
                                     `}

                                id="id1BackArea"
                                onClick={() => {
                                    if (!isIdType1Selected) {
                                        toast.error("Please select ID Type");
                                        return;
                                    }
                                    // if (isIdType1Passport) return;

                                    document.getElementById("id1Back").click();
                                }}
                            >
                                {!indivInvFormData?.id1BackName && (
                                    <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                        <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                    </svg>
                                )}
                                {/*  Uploaded icon */}
                                {indivInvFormData?.id1BackName && (

                                    <svg width="40" height="40" viewBox="0 0 24 24">
                                        <circle cx="12" cy="12" r="10" fill="#10b981" />
                                        <path
                                            d="M8 12.5l2.5 2.5L16 9"
                                            fill="none"
                                            stroke="#ffffff"
                                            strokeWidth="2.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                )}


                                <p className="upload-title">
                                    {indivInvFormData?.id1BackName
                                        ? "Uploaded"
                                        : "Click to upload back side"}
                                </p>


                                <p className={`upload-hint ${indivInvFormData?.id1BackName ? "hidden" : ""}`}>
                                    PNG, JPG up to 5MB
                                </p>



                                <span className="file-name"
                                    title={indivInvFormData?.id1BackName || ""}
                                > {truncateFileName((indivInvFormData?.id1BackName), 40) || "No file selected"}
                                </span>

                                {indivInvFormData?.id1BackName && (
                                    <div
                                        className="file-actions"
                                        onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                    >
                                        {/* View */}
                                        <button
                                            type="button"
                                            className="icon-btn view"
                                            title="View file"
                                            onClick={() => handleViewFile("id_back")}

                                        >
                                            <FaEye
                                                className="eye-view-color-kyc"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"


                                            />
                                        </button>

                                        {/* REMOVE */}
                                        <button
                                            type="button"
                                            className="icon-btn cancel"
                                            title="Remove file"
                                            onClick={() => handleDeleteFile("id_back")}
                                        >
                                            ✕
                                        </button>
                                    </div>
                                )}
                            </div>

                            <input
                                type="file"
                                id="id1Back"
                                accept="image/*"
                                hidden
                                disabled={!isIdType1Selected}

                                onChange={(e) => handleIdentityChange(e, "id1Back")}

                            />
                        </div>

                    </div>

                    <div
                        style={{
                            marginTop: "30px",
                            paddingTop: "17px",
                            borderTop: "2px solid #e5e7eb",
                            width: "100%",
                        }}
                    >
                        <div className="row mt-1">
                            <h6 className="section-title">
                                Second ID Document</h6>
                        </div>

                        <div className="row allow-gutter gy-3">

                            <div className="col-lg-6 settings_YOE ">
                                <label htmlFor="country" className="nomine-relation-label">

                                    ID Type #2  <span className="required">*</span>
                                </label>


                                <select
                                    className={`form-select dropdn_select_cls_settings shadow-ben APNL_option_flds ${validateIdErrors.idType2 ? "input-error" : ""
                                        }`}
                                    value={idType2 || ""}




                                    onChange={(e) => {
                                        const value = e.target.value;

                                        setIndivInvFormData(prev => {
                                            const updated = {
                                                ...prev,
                                                idType2: value,

                                                id2Front: "",
                                                id2FrontBlobUrl: "",
                                                id2FrontName: "",
                                                id2Back: "",
                                                id2BackBlobUrl: "",
                                                id2BackName: "",
                                            };

                                            localStorage.setItem(`indivInvData_${indivInvFormData?.user_id}`, JSON.stringify(updated));

                                            return updated;
                                        });

                                        setUploadedFiles(prev => {
                                            const updated = { ...prev };
                                            delete updated.id_front2;
                                            delete updated.id_back2;

                                            saveDraft({
                                                investorKycId,
                                                currentStep,
                                                formData: {
                                                    ...getFormData(),
                                                    idType2: value,
                                                    id2Front: "",
                                                    id2FrontBlobUrl: "",
                                                    id2FrontName: "",
                                                    id2Back: "",
                                                    id2BackBlobUrl: "",
                                                    id2BackName: "",
                                                },
                                                uploadedFiles: updated,
                                                livenessSessionId,
                                            });

                                            return updated;
                                        });


                                        if (
                                            value &&
                                            value === idType1 &&
                                            UNIQUE_ID_TYPES.includes(value)
                                        ) {
                                            handleFieldChange("idType1", "");
                                        }
                                    }}
                                >
                                    <option value="">Select</option>
                                    {idType2Options.map((type) => (
                                        <option key={type} value={type}>
                                            {type}
                                        </option>
                                    ))}
                                </select>

                            </div>
                        </div>


                        <div className="upload-grid">

                            {/* FRONT SIDE */}
                            <div className="form-group">
                                <label className="kyc-label">
                                    Front Side <span className="required">*</span>
                                </label>

                                <div
                                    className={`upload-area ${identityError.id2Front ? "input-error" : ""}
                                    ${indivInvFormData?.id2FrontName ? "has-file" : ""}
                                    ${!isIdType2Selected ? "upload-disabled" : ""}

                                    `}

                                    id="id2FrontArea"
                                    onClick={() => {
                                        if (!isIdType2Selected) {
                                            toast.error("Please select ID Type");
                                            return;
                                        }
                                        document.getElementById("id2Front").click();
                                    }}
                                >
                                    {!indivInvFormData?.id2FrontName && (
                                        <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                            <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                        </svg>
                                    )}
                                    {indivInvFormData?.id2FrontName && (

                                        <svg width="40" height="40" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" fill="#10b981" />
                                            <path
                                                d="M8 12.5l2.5 2.5L16 9"
                                                fill="none"
                                                stroke="#ffffff"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}

                                    <p className="upload-title">
                                        {indivInvFormData?.id2FrontName
                                            ? "Uploaded"
                                            : "Click to upload front side"}
                                    </p>

                                    <p className={`upload-hint ${indivInvFormData?.id2FrontName ? "hidden" : ""}`}>
                                        PNG, JPG up to 5MB
                                    </p>


                                    <span className="file-name"
                                        title={indivInvFormData?.id2FrontName || ""}
                                    > {truncateFileName((indivInvFormData?.id2FrontName), 40) || "No file selected"}
                                    </span>

                                    {indivInvFormData?.id2FrontName && (
                                        <div
                                            className="file-actions"
                                            onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                        >
                                            {/* View */}
                                            <button
                                                type="button"
                                                className="icon-btn view"
                                                title="View file"
                                                onClick={() => handleViewFile("id_front2")}

                                            >

                                                <FaEye
                                                    className="eye-view-color-kyc"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"


                                                />
                                            </button>

                                            {/* REMOVE */}
                                            <button
                                                type="button"
                                                className="icon-btn cancel"
                                                title="Remove file"
                                                onClick={() => handleDeleteFile("id_front2")}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <input
                                    type="file"
                                    id="id2Front"
                                    accept="image/*"
                                    onChange={(e) => handleIdentityChange(e, "id2Front")}
                                    hidden
                                    disabled={!isIdType2Selected}

                                />
                            </div>

                            {/* BACK SIDE */}
                            <div className="form-group">
                                <label className="kyc-label">
                                    Back Side
                                    {/* <span className="required">*</span> */}
                                    {!isIdType2Passport && <span className="required">*</span>}

                                </label>

                                <div
                                    className={`upload-area ${identityError.id2Back ? "input-error" : ""}
                                                                             ${indivInvFormData?.id2BackName ? "has-file" : ""}
                                                                                                                       ${!isIdType2Selected ? "upload-disabled" : ""}`}

                                    id="id2BackArea"
                                    onClick={() => {
                                        if (!isIdType2Selected) {
                                            toast.error("Please select ID Type");
                                            return;
                                        }
                                        //  if (isIdType2Passport) return;
                                        document.getElementById("id2Back").click();
                                    }}
                                >
                                    {!indivInvFormData?.id2BackName && (
                                        <svg width="40" height="40" fill="#9ca3af" viewBox="0 0 24 24">
                                            <path d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" />
                                        </svg>
                                    )}
                                    {indivInvFormData?.id2BackName && (

                                        <svg width="40" height="40" viewBox="0 0 24 24">
                                            <circle cx="12" cy="12" r="10" fill="#10b981" />
                                            <path
                                                d="M8 12.5l2.5 2.5L16 9"
                                                fill="none"
                                                stroke="#ffffff"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}

                                    <p className="upload-title">
                                        {indivInvFormData?.id2BackName
                                            ? "Uploaded"
                                            : "Click to upload back side"}
                                    </p>

                                    <p className={`upload-hint ${indivInvFormData?.id2BackName ? "hidden" : ""}`}>
                                        PNG, JPG up to 5MB
                                    </p>


                                    <span className="file-name"
                                        title={indivInvFormData?.id2BackName || ""}
                                    > {truncateFileName((indivInvFormData?.id2BackName), 40) || "No file selected"}
                                    </span>

                                    {indivInvFormData?.id2BackName && (
                                        <div
                                            className="file-actions"
                                            onClick={(e) => e.stopPropagation()} // prevent re-upload click
                                        >
                                            {/* View */}
                                            <button
                                                type="button"
                                                className="icon-btn view"
                                                title="View file"
                                                onClick={() => handleViewFile("id_back2")}

                                            >

                                                <FaEye
                                                    className="eye-view-color-kyc"
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"


                                                />
                                            </button>

                                            {/* REMOVE */}
                                            <button
                                                type="button"
                                                className="icon-btn cancel"
                                                title="Remove file"
                                                onClick={() => handleDeleteFile("id_back2")}
                                            >
                                                ✕
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <input
                                    type="file"
                                    id="id2Back"
                                    accept="image/*"
                                    onChange={(e) => handleIdentityChange(e, "id2Back")}
                                    hidden
                                    disabled={!isIdType2Selected}
                                />
                            </div>

                        </div>
                    </div>

                    <div className="button-group">
                        <button className="btn btn-secondary" onClick={onBack}>← Back</button>
                        <button className="btn btn-primary"
                            onClick={() => {

                                const isValid = validateMandatoryFields();
                                if (!isValid) {
                                    removeCompletedStep(3); // 
                                    return; //  stop navigation
                                }

                                handleSaveKYCDraft();
                                onNext();
                            }}
                        >Continue →</button>
                    </div>




                </div>
            </div>
        </div >



    );
};

export default InvestorIdentityVerification;
